import { mapProductPrice, RawProductPrice } from '~/Api/Product';
import Price from '~/utils/Price/Price';

import PublicReferencePrice from './PublicReferencePrice';

export interface RawPublicReferencePrice {
	sourcePrice: RawProductPrice;
	convertedPrice: Price;
}

export default function mapPublicReferencePrice(referencePrice: RawPublicReferencePrice): PublicReferencePrice {
	const { sourcePrice, convertedPrice } = referencePrice;
	return new PublicReferencePrice(
		mapProductPrice(sourcePrice),
		new Price(convertedPrice.value, convertedPrice.currency)
	);
}
